import {Material} from '@hconnect/common/types'
import {Stack} from '@mui/material'
import {useCallback} from 'react'

import {useElementWidth} from '../../../shared/hooks/useElementWidth'

import {OptimizerStockLevelsChart} from './detail/stockLevelsChart/OptimizerStockLevelsChart'
import {OptimizerStockLevelInfo} from './OptimizerStockLevelInfo'
import {useSelectedMaterialId} from './SelectedMaterialIdProvider'

type OptimizerStockLevelIndicatorProps = {
  material: Material
}

const INFO_ELEMENT_WIDTH = 60

export const OptimizerStockLevelIndicator = (props: OptimizerStockLevelIndicatorProps) => {
  const [containerRef, containerWidth] = useElementWidth()

  const materialId = props.material.id

  const {selectMaterialId} = useSelectedMaterialId()
  const selectThisMaterial = useCallback(() => {
    selectMaterialId(materialId)
  }, [materialId, selectMaterialId])

  return (
    <Stack
      spacing={1}
      sx={{width: '100%', cursor: 'pointer'}}
      onClick={selectThisMaterial}
      alignItems="center"
      ref={containerRef}
    >
      <OptimizerStockLevelsChart width={containerWidth - INFO_ELEMENT_WIDTH} {...props} />
      <OptimizerStockLevelInfo {...props} />
    </Stack>
  )
}
